import {
    type ApplicantDocument,
    ApplicantDocumentDto,
} from "@sr-partner-portal/common";
import { BaseApiService } from "./base-api-service";

class ApplicantDocumentsApiService extends BaseApiService {
    // async getAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes().applicantDocuments().get(false, { id }).build(),
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }

    // async getByApplicantIdAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .getByApplicantId(false, { id })
    //             .build(),
    //     );

    //     const applicantDocuments: ApplicantDocument[] =
    //         responseData.applicantDocumentDtos.map((xApplicantDocument) =>
    //             ApplicantDocumentDto.createFromApplicantDocument(
    //                 xApplicantDocument,
    //             ).toApplicantDocument(),
    //         );

    //     return applicantDocuments;
    // }

    async getByShareLinkToken(token: string) {
        const responseData = await this._apiHttpService.getAsync(
            this._apiRoutes()
                .applicantDocuments()
                .getByShareLinkToken(false, { token })
                .build(),
        );

        const applicantDocuments: ApplicantDocument[] =
            responseData.applicantDocumentDtos.map((xApplicantDocument) =>
                ApplicantDocumentDto.createFromApplicantDocument(
                    xApplicantDocument,
                ).toApplicantDocument(),
            );

        return applicantDocuments;
    }

    // async getDownloadUrlAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .getDownloadUrl(false, { id })
    //             .build(),
    //     );

    //     return responseData as { downloadUrl: string };
    // }

    // async getDownloadAllForApplicantUrlAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .getDownloadAllForApplicantUrl(false, { id })
    //             .build(),
    //     );

    //     return responseData as { downloadUrl: string };
    // }

    async getDownloadUrlByShareLinkToken({
        id,
        token,
    }: {
        id: number;
        token: string;
    }) {
        const responseData = await this._apiHttpService.getAsync(
            this._apiRoutes()
                .applicantDocuments()
                .getDownloadUrlByShareLinkToken(false, { id })
                .build({ token }),
        );

        return responseData as { downloadUrl: string };
    }

    // async getPreviewUrlAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .getPreviewUrl(false, { id })
    //             .build(),
    //     );

    //     return responseData as { previewUrl: string };
    // }

    async getPreviewUrlByShareLinkToken({
        id,
        token,
    }: {
        id: number;
        token: string;
    }) {
        const responseData = await this._apiHttpService.getAsync(
            this._apiRoutes()
                .applicantDocuments()
                .getPreviewUrlByShareLinkToken(false, { id })
                .build({ token }),
        );

        return responseData as { previewUrl: string };
    }

    // async getThumbnailUrlAsync(id: number) {
    //     const responseData = await this._apiHttpService.getAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .getThumbnailUrl(false, { id })
    //             .build(),
    //     );

    //     return responseData as { thumbnailUrl: string };
    // }

    async getThumbnailUrlByShareLinkToken({
        id,
        token,
    }: {
        id: number;
        token: string;
    }) {
        const responseData = await this._apiHttpService.getAsync(
            this._apiRoutes()
                .applicantDocuments()
                .getThumbnailUrlByShareLinkToken(false, { id })
                .build({ token }),
        );

        return responseData as { thumbnailUrl: string };
    }

    // async markReadAsync(id: number) {
    //     const responseData = await this._apiHttpService.putAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .markRead(false, { id })
    //             .build(),
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }

    // async markAllReadForApplicant(id: number) {
    //     const responseData = await this._apiHttpService.putAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .markAllReadForApplicant(false, { id })
    //             .build(),
    //     );

    //     if (responseData.success !== true) {
    //         return false;
    //     }

    //     return true;
    // }

    // async markUnreadAsync(id: number) {
    //     const responseData = await this._apiHttpService.putAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .markUnread(false, { id })
    //             .build(),
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }

    // async removeAsync(id: number) {
    //     const responseData = await this._apiHttpService.removeAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .remove(false, { id })
    //             .build(),
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }

    // async renameAsync({ id, name }: { id: number; name: string }) {
    //     const responseData = await this._apiHttpService.putAsync(
    //         this._apiRoutes()
    //             .applicantDocuments()
    //             .rename(false, { id })
    //             .build(),
    //         { name },
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }

    // async createAsync(formData: FormData) {
    //     const responseData = await this._apiHttpService.postFormDataAsync(
    //         this._apiRoutes().applicantDocuments().create().build(),
    //         formData,
    //     );

    //     const applicantDocumentDto =
    //         ApplicantDocumentDto.createFromApplicantDocumentData(
    //             responseData.applicantDocumentDto,
    //         );
    //     const applicantDocument = applicantDocumentDto.toApplicantDocument();
    //     return applicantDocument;
    // }
}

export { ApplicantDocumentsApiService };
